import MissingSite from './MissingSite';

export default MissingSite;
